export class ApplicationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanInfo({ signal, ...params }) {
    return this.#http.get('/loan/info', {
      params,
      signal,
      paramsSerializer: { indexes: true },
    });
  }

  async getLoanInfoByPipeline({ signal, ...params }) {
    return this.#http.get('/loan/info/by-pipeline', {
      params,
      signal,
      paramsSerializer: { indexes: true },
    });
  }

  async getLoanInfoWithLegacyData({ signal, ...params }) {
    return this.#http.get('/loan/info-with-legacy-data', { params, signal });
  }

  async editTransactionRelated({ withLoanOptionId, loanId, ...body }) {
    return this.#http.put(`/loan/${loanId}/transaction-related`, body, {
      params: { withLoanOptionId },
    });
  }

  async getLoanAdjustments({ loanId }) {
    return this.#http.get(`/loan/${loanId}/adjustments`);
  }

  async createLoanClone({ loanId, ...body }) {
    return this.#http.post(`/loan/${loanId}/clone`, body);
  }

  async createLoanOptions({ loanId, ...body }) {
    return this.#http.post(`/loan/${loanId}/loan-options`, body);
  }

  async createLoanOptionsWithPending({ applicationId, signal, ...body }) {
    return this.#http.post(`/application/${applicationId}/loan-options`, body, { signal });
  }

  async getAtParLoanOptions({ applicationId, signal, ...body }) {
    return this.#http.post(`/application/${applicationId}/at-par-loan-options`, body, { signal });
  }

  async getProgramRatesheet({ applicationId, signal, ...body }) {
    return this.#http.post(`/application/${applicationId}/at-par-loan-options/ratesheet`, body, {
      signal,
    });
  }

  async createLoanOptionsByRateSheet({ loanId, ...body }) {
    return this.#http.post(`/loan/${loanId}/loan-options-by-rate-sheet`, body);
  }

  async cancelSendingBundle({ loanId, ...params }) {
    return this.#http.delete(`/loan/${loanId}/cancel-sending-bundle`, { params });
  }

  async getRateSheets({ loanId }) {
    return this.#http.get(`/loan/${loanId}/rate-sheets`);
  }

  async getAusReports({ loanId, ...params }) {
    return this.#http.get(`/loan/${loanId}/aus-reports`, { params });
  }

  // DEV-4826: dedicated comp-FREE loan-role assignment facade (SkynetAPI DEV-4716). Persists a
  // staffing assignment on its own call so a broker can staff roles pre-pricing without tripping the
  // comp validation that the shared loan-info commit runs (which 409s on unpriced loans).
  async createLoanRoleAssignment({ applicationId, ...body }) {
    return this.#http.post(`/application/${applicationId}/loanRoleAssignments`, body);
  }

  async updateLoanRoleAssignment({ applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/loanRoleAssignments`, body);
  }
}
